export default __webpack_public_path__ + "locales/es/InfoPanel.json?hash=eb80b116eb8d2b7876ac482cf118b24e";